import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { setAuthAction, doneLoading, startLoading, setOverlay } from '../../Redux/actions/index';

import api from '../../Utils/Api';
import Select from 'react-select';



const mapStateToProps = state => {
	return {
		user: state.user,
		loading: state.loading
	}
}

function mapDispatchToProps(dispatch) {
  return {
    setAuth: user => dispatch(setAuthAction(user)),
    doneLoading: () => dispatch(doneLoading()),
    setOverlay: (x) => dispatch(setOverlay(x)),
    isLoading: (e) => dispatch(startLoading(e))
  };
}



class LinkNewContainer extends Component {

	constructor(props) {
		super(props);

		//	this.props.isLoading({message: "Loading", animate:true});

		
		this.state = {
			agents: [],
			types: [],
			wilayas: []
			
		}

		
	}

	pinToggle() {
		
	}

	submitTask = (e) => {
		e.preventDefault();
		let that = this;

		this.props.isLoading({
			message:"Adding link",
			animate:true
		});
		

		const formdata = new FormData(this.taskForm);

		
		let data = {};

		for(var [key, value] of formdata.entries()) 
			data[key] = value
		
		console.log(data);

		data['user'] = this.props.user;


		api.post('/api/link/new', (data))
		.then(function(response) {

			if(response.data.success) {

				//window.ga('send', 'event', 'task', 'add'); // Google Analytics

				that.props.history.push('/link');

				that.props.setOverlay({
					message: 'Link successfully added !',
					label: "success",
					button: {
						type: "close",
						label: "Dismiss",
						link: "javascript:void(0)"
					}
				});
			} else {
				if(response.data.errcode === 101) {
					that.props.setAuth(response.data)
				}
			}

			that.props.doneLoading();


			
		}).catch(err => that.props.doneLoading());
		
	}


	
	componentDidMount() {
		
		
		
		let that = this;

		api.get('/api/task/form?token='+this.props.user.token)
		.then(function(response) {
			that.setState({agents: response.data.agents, types: response.data.types, status: response.data.status, wilayas: response.data.wilayas})
		});

	}


	render() {
		

		return(

			
			<React.Fragment>
			<div className={"container-header"}>
				New Link
			</div>

			
			<form ref={ref => this.taskForm = ref} onSubmit={this.submitTask}>
			
				<div className={"row"}>
					<div className={"col-md-4 taskForm"}>

						<div className={"form-group"}>
							<label>Owner  </label>
							<Select
							name={"link_owner"}
							//className={"classnametest"}
							classNamePrefix={"custom-select"}
							options={[
								{label: "Ooredoo", value: "ooredoo"},
								{label: "Djezzy", value: "djezzy"}
							]}
							placeholder="Link owner"
							/>
						</div>
						
						<div className={"form-group"}>
							<label>Link name/code  </label>
							<input type="text" name="link_name" className={"form-control"} />
						</div>

						<div className={"form-group"}>
							<label>Section  </label>
							<Select
							name="link_section"
							classNamePrefix={"custom-select"}
							options={[
								{ label: "Centre", value: "middle" },
								{ label: "Est", value: "east" },
								{ label: "Ouest", value: "west" },
								{ label: "Sud", value: "south" }
								
							]}
							cacheOptions
							defaultOptions 
							placeholder="Region"
							className={"d-block mt-1"}
							/>
						</div>

						<div className={"form-group"}>
							<label>Section  </label>
							<Select
							classNamePrefix={"custom-select"}
							options={this.state.wilayas}
							cacheOptions
							defaultOptions 
							placeholder="Wilaya"
							className={"d-block mt-1"}
							name={"link_wilaya"}
							/>
						</div>




						<div className={"form-group"}>
							<button type="submit" className={"cbtn float-right"}>Ajouter</button>
						</div>

					</div>


				</div>

			</form>
			</React.Fragment>
			
		)
	}
}


export default connect(mapStateToProps, mapDispatchToProps)(LinkNewContainer)